export default __webpack_public_path__ + "static/media/brendel.1b8063ad.jpg";